import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'formatBytes', standalone: true })
export class FormatBytesPipe implements PipeTransform {
  constructor(private translate: TranslateService) { }

  // convert bytes to KB, MB etc.
  transform(bytes: number, decimals = 2): any {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
      this.translate.instant('Bytes'),
      this.translate.instant('KB'),
      this.translate.instant('MB'),
      this.translate.instant('GB'),
      this.translate.instant('TB'),
      this.translate.instant('PB'),
      this.translate.instant('EB'),
      this.translate.instant('ZB'),
      this.translate.instant('YB'),
    ];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
}
